import { Injectable } from '@angular/core';
import { UserDefinition, UserDefinitionList, UserService } from 'com.trumbull.phx.user.api-client';
import { ReplaySubject, Observable, catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserHelperService {
  private cache = new Map<string, ReplaySubject<UserDefinition[]>>();
  constructor(private userService: UserService) {}

  getUsersByAttribute(attributeKey?: string, attributeValue?: string): Observable<UserDefinition[]> {
    const cacheKey = `${attributeKey || ''}:${attributeValue || ''}`;

    if (!this.cache.has(cacheKey)) {
      const subject = new ReplaySubject<UserDefinition[]>(1);
      this.cache.set(cacheKey, subject);

      this.userService
        .listUsers(
          undefined,      // searchDisplayNames
          undefined,      // displayName
          undefined,      // firstName
          undefined,      // lastName
          undefined,      // email
          undefined,      // replyToEmail
          undefined,      // externalId
          undefined,      // enabled
          undefined,      // managerId
          attributeKey,   // attributeKey
          attributeValue, // attributeValue
          undefined,      // team
          'RR:Orderer',   // roleCode
          undefined,      // id
          '+displayName', // sort
          1,              // page
          999,            // pageSize
          undefined,      // includeLockStatus
          'body',         // observe
          false           // reportProgress
        )
        .pipe(
          catchError((error) => {
            console.error(`User API error for key "${cacheKey}":`, error);
            subject.error(error);
            return [];
          })
        )
        .subscribe({
          next: (response) => {
            subject.next(response.users || []);
            subject.complete();
          }
        });
    }

    return this.cache.get(cacheKey)!.asObservable();
  }

  // Optional: clear a specific cache
  clearCache(attributeKey?: string, attributeValue?: string): void {
    const cacheKey = `${attributeKey || ''}:${attributeValue || ''}`;
    this.cache.delete(cacheKey);
  }

  // Optional: clear all caches
  clearAll(): void {
    this.cache.clear();
  }
}
